import { CourseForm, CourseTree } from '@/entities/trainings';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPutRequest,
  createAuthorizedPostRequest,
  decode,
  decodeId,
  fetchApi,
  setBody,
  setQuery,
} from '@/services/api';
import { resourceBulkDelete } from '@/services/api/resources/bulkDelete';
import { flow } from 'fp-ts/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { coursesListCodec, courseTreeCodec } from './codec';
import { encodeCourseQuery, CourseQuery } from './query';

const baseUrl = '/v2/trainings/courses';
const recordUrl = (id: number) => `${baseUrl}/${id}`;

export const list = (query: CourseQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeCourseQuery(query))),
  chain(fetchApi),
  chain(decode(coursesListCodec)),
);

export const create = (course: CourseForm) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(course)),
  chain(fetchApi),
  chain(decodeId),
);

export const bulkDelete = (records: number[]) => resourceBulkDelete(records, baseUrl);

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(courseTreeCodec)),
);

export const update = (id: number, course: CourseTree) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(setBody(course)),
  chain(fetchApi),
);
